import { render } from "./sendForm.vue?vue&type=template&id=4c743078"
import script from "./sendForm.vue?vue&type=script&lang=js"
export * from "./sendForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__